import * as XLSX from 'xlsx/xlsx.mjs';
import {t} from "@lingui/core/macro";
import AppService from '../../../services/AppService';
import { currencyFormat } from '../../../components/permissions/functions';


export function translateLivretType(item,withExtra=false)
{
    if(!item?.type){
        return null
    }

    switch (item.type)
    {
        case "GENERAL":
            return t`Caisse Principale`
        case "LIVRET":
            return t`Livret: ${item.data.label}`
        case "CAMPAGNE":
            return t`Campagne: ${item.data.label}`
        case "CAISSE":
            return t`Cagnotte: ${item.data.label}`
        case "DETTE":
            return t`Promesse: ${item.data.name}`
        case "GROUPE":
            return t`Groupe Service: ${item.data.name}`
        case "FORM":
            let _label=t`Formulaire: ${item.data.formData.label}`
            if(withExtra){
                _label+=t` (reste ${currencyFormat(item.data.reste,item.data.devise)})`
            }
            return _label
        default:
            return item.label
    }
}

export function translateType(type, row = {}) {
    switch (type) {
        case "GENERAL":
            return t`Caisse Principale`
        case "LIVRET":
            return t`Livret`
        case "CAMPAGNE":
            return t`Campagnes`
        case "CAISSE":
            return t`Cagnotte`
        case "DETTE":
            return t`Promesse`
        case "GROUPE":
            return t`Groupe de Service`
        case "FORM":
            return t`Formulaire`
        case "SERVICE":
            if (row?.service?.recurrent) {
                return t`Service Recurrent`
            } else {
                return t`Service`
            }
    }
}

export function translateMethod(type) {
    switch (type) {
        case "CB":
            return t`Carte Bancaire`
        case "CHEQUE":
            return t`Chèque`
        case "VIREMENT":
            return t`Virement`
        case "PRELEVEMENT":
            return t`Prélèvement`
        case "CASH":
            return t`Espèces`
        case "NATURE":
            return t`En Nature`
        default:
            return type
    }
}

export function translateMethodIcon(type) {
    switch (type) {
        case "CB":
            return "credit-card"
        case "CHEQUE":
            return "tickets"
        case "VIREMENT":
            return "arrow-right-left"
        case "PRELEVEMENT":
            return "landmark"
        case "CASH":
            return "coins"
        case "NATURE":
            return "handshake"
        default:
            return type
    }
}

export function translateSource(source) {
    switch (source) {
        case "WEB":
            return t`En ligne`
        case "ADMIN":
            return t`Manuellement`
        case "SYSTEM":
            return t`Logiciel`
        case "BORNE":
            return t`Borne de don`
        default:
            return null
    }
}

export function translateSourceIcon(source) {
    switch (source) {
        case "WEB":
            return "globe"
        case "ADMIN":
            return "shield-user"
        case "SYSTEM":
            return "cog"
        case "BORNE":
            return "tablet"
        default:
            return source
    }
}

export function translatePlatform(platform) {
    switch (platform) {
        case "STRIPE":
            return "Stripe"
        case "PAYGREEN":
            return "Paygreen"
        case "GOCARDLESS":
            return "GoCardless"
        default:
            return platform
    }
}

export function translateAbonnementStatus(state) {
    switch (state) {
        case "ACTIVE":
            return t`En cours`
        case "MANUAL":
            return t`Interrompue`
        case "CARD_EXPIRED":
            return t`Carte expiré`
        case "PAUSE":
            return t`En pause`
        case "FINISHED":
            return t`Terminé`
        default:
            return state
    }
}

export function formatedAbonnementError(row) {
    if (typeof row.error === "string") {
        return row.error
    }

    if (typeof row.error === "object") {
        if (row.error?.message) {
            return row.error?.message
        }
    }

    return null
}

function fitToColumn(arrayOfArray) {
    return arrayOfArray[0].map((a, i) => ({
        wch: Math.max(...arrayOfArray.map(a2 => a2[i] ? a2[i].toString().length : 0))
    }));
}

export function exportCsv(filename, headers, data) {
    const arrayOfArray = [headers, ...data]
    var worksheet = XLSX.utils.aoa_to_sheet(arrayOfArray);
    worksheet['!cols'] = fitToColumn(arrayOfArray);

    const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
    var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
    var wbout = XLSX.write(workbook, wopts);

    filename = filename.replace(".csv", ".xlsx")


    console.log("window.MOBILE_NEW_UI",window.MOBILE_NEW_UI)

    if(window.MOBILE_NEW_UI)
    {
        console.log("SHARE TO APP",filename)
        const base64="data:application/octet-stream,"+btoa(String.fromCharCode.apply(null, new Uint8Array(wbout)));
        AppService.share({url:base64,filename:filename})
    }else
    {
        var blob = new Blob([wbout], { type: "application/octet-stream" })
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
}
